import { Close, Edit } from '@mui/icons-material'
import { Box, Button, IconButton, ListItem, TextField } from '@mui/material'
import React, { useState } from 'react'
import useIsAdmin from '../../../hooks/useIsAdmin'
import { StatusDropdown } from '../../../dashboard/TaskItem'
import { green, grey, orange } from '@mui/material/colors'

const Note = ({
  note,
  deleteNote,
  updateNote,
  canEdit,
  taskStatusTypes = [],
  index,
}) => {
  const [isEditing, setIsEditing] = useState(false)

  const [localCopy, setLocalCopy] = useState(JSON.parse(JSON.stringify(note)))

  const createdDate = new Date(localCopy.createdOn).toLocaleDateString()

  const { isAdmin } = useIsAdmin()

  const isActiveTask = [1, 2].includes(note.statusTypeId)

  const task = isActiveTask
    ? {
        id: note.taskId,
        statusTypeId: note.statusTypeId,
        taskTypeId: note.taskTypeId,
        typeName: note.taskTypeName,
        outcome: note.outcome,
        taskTypeOutcomeName: note.taskTypeOutcomeName,
        outcomeNote: note.outcomeNote,
      }
    : null

  const updateTaskStatus = (t, e) => {
    setLocalCopy((prev) => ({ ...prev, statusTypeId: e.target.value }))

    updateNote({ ...note, statusTypeId: e.target.value })
  }

  const resolvedNote = localCopy.taskNote || localCopy.note

  return (
    <ListItem
      sx={{
        display: 'block',
        borderTop: index !== 0 ? `1px solid grey` : null,
        py: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <div>
            <b>
              <span>{createdDate}</span>
              {' - '}
              <span>
                {localCopy.authorName || 'Original Note from Account'}
              </span>
              {localCopy.taskTypeName && (
                <>
                  {' - '}
                  <span>{localCopy.taskTypeName}</span>
                </>
              )}

              {!!resolvedNote && ':'}
            </b>
          </div>
          {(localCopy.outcome || localCopy.taskTypeOutcomeName) && (
            <div>
              {
                <span
                  style={{
                    color:
                      localCopy.outcome === 'Successful'
                        ? green[800]
                        : localCopy.outcome === 'Unsuccessful'
                        ? orange[800]
                        : grey[700],
                  }}
                >
                  <b>{localCopy.outcome}</b>
                </span>
              }

              {localCopy.outcome && localCopy.taskTypeOutcomeName && <> - </>}

              <span style={{ color: grey[700] }}>
                <b>{localCopy.taskTypeOutcomeName}</b>
              </span>
            </div>
          )}
          <div style={{ marginTop: '4px' }}>
            {!isEditing && (
              <>
                {localCopy.outcomeNote && (
                  <div>
                    <span style={{ whiteSpace: 'break-spaces' }}>
                      {localCopy.outcomeNote}
                    </span>
                  </div>
                )}
                <div>
                  <span style={{ whiteSpace: 'break-spaces' }}>
                    {resolvedNote}
                  </span>
                </div>
              </>
            )}
          </div>
          {isEditing && (
            <TextField
              size='sm'
              margin='dense'
              label='Note'
              onChange={(e) =>
                setLocalCopy((prev) => ({ ...prev, note: e.target.value }))
              }
              value={resolvedNote}
              multiline
              minRows={3}
              maxRows={15}
              fullWidth
            />
          )}
        </Box>
        {!isEditing && isActiveTask && (
          <Box sx={{ maxWidth: '300px' }}>
            <StatusDropdown
              t={task}
              taskStatusTypes={taskStatusTypes}
              updateTaskStatus={updateTaskStatus}
            />
          </Box>
        )}
        <Box>
          {canEdit && !isEditing && (
            <>
              <IconButton onClick={() => setIsEditing(true)}>
                <Edit />
              </IconButton>
              {isAdmin && (
                <IconButton onClick={() => deleteNote()}>
                  <Close />
                </IconButton>
              )}
            </>
          )}
          {isEditing && (
            <Button
              color='primary'
              onClick={() => {
                updateNote(localCopy)
                setIsEditing(false)
              }}
            >
              Save Note
            </Button>
          )}
        </Box>
      </Box>
    </ListItem>
  )
}

export default Note
